import { store } from "@/store/store";
import { pacientes_leads } from "@/shared/dtos/pacientes_leads";
import { VuexModule, Mutation, getModule, Module, Action } from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";

@Module({ namespaced: true, name: "pacientesLeadsModule", store, dynamic: true })
class pacientesLeadsModule extends VuexModule {
  public rows: pacientes_leads[] = [];
  public row: pacientes_leads = new pacientes_leads();

  @Action({ commit: "onGetRows" })
  public async getRows() {
    return await ssmHttpService.get(API.pacientes_leads);
  }

  @Action({ commit: "onGetRow" })
  public async getRow(id: any) {
    return await ssmHttpService.get(API.pacientes_leads + "/" + id);
  }

  @Action
  public async guardar(item: pacientes_leads) {
    return await ssmHttpService.post(API.pacientes_leads, item.toJson(["created_at", "updated_at"]));
  }

  @Action
  public async modificar(item: pacientes_leads) {
    return await ssmHttpService.put(API.pacientes_leads + "/" + item.id, item.toJson(["created_at", "updated_at"]));
  }

  @Action
  public async eliminar(item: pacientes_leads) {
    return await ssmHttpService.delete(API.pacientes_leads + "/" + item.id, null, false);
  }

  @Mutation
  public onGetRows(res: pacientes_leads[]) {
    this.rows = res ? res.map((x) => new pacientes_leads(x)) : [];
  }

  @Mutation
  public onGetRow(res: pacientes_leads) {
    this.row = new pacientes_leads(res);
  }
}

export default getModule(pacientesLeadsModule);
